/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * SystemOverrideOrigin defines the reason why a system override was triggered.   - SYSTEM_OVERRIDE_ORIGIN_CONTINUOUS_OOM_KILLED: Override triggered due to continuous OOM kills after multiple scaling attempts.  - SYSTEM_OVERRIDE_ORIGIN_UNBOUND_MEMORY_GROWTH: Override triggered due to detected unbound memory growth.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1SystemOverrideOrigin = {
    UNSPECIFIED: 'SYSTEM_OVERRIDE_ORIGIN_UNSPECIFIED',
    CONTINUOUS_OOM_KILLED: 'SYSTEM_OVERRIDE_ORIGIN_CONTINUOUS_OOM_KILLED',
    UNBOUND_MEMORY_GROWTH: 'SYSTEM_OVERRIDE_ORIGIN_UNBOUND_MEMORY_GROWTH'
} as const;

export type WorkloadoptimizationV1SystemOverrideOrigin = typeof WorkloadoptimizationV1SystemOverrideOrigin[keyof typeof WorkloadoptimizationV1SystemOverrideOrigin];



